module.exports = __webpack_public_path__ + "static/media/mobile2.3b17b1db.png";